'use client';

import React from 'react';
import PromotionalCategoryGrid from 'components/commercetools-ui/organisms/promotional-category-grid';
import { GridProps } from 'components/commercetools-ui/organisms/promotional-category-grid/types';
import { TasticProps } from '../types';

const PromotionalCategoryGridTastic = ({ data }: TasticProps<GridProps>) => {
  return <PromotionalCategoryGrid {...data} />;
};

export default PromotionalCategoryGridTastic;
